<script setup>
import {ref} from "vue"

const props = defineProps({
    timeout: Number
})

const alertMessage = ref('')
const showToast = ref(false)
const toastOptions = ref({
    icon: 'mdi-check',
    dismissible: true,
    color: 'success',
    timeout: 3000,
})

// colors = primary, secondary, success, info, warning, error
let toastCompleted
const emit = async (message = 'Success Message', type = 'success', options = {}) => {
    alertMessage.value = message
    toastOptions.value = {
        ...toastOptions.value,
        ...options,
        type: type
    }

    showToast.value = true

    return new Promise((resolve) => {
        toastCompleted = resolve
    }).then(() => {
        showToast.value = false
    })
}

defineExpose({emit})
</script>

<template>
    <v-snackbar
        v-model="showToast"
        :timeout="toastOptions.timeout || -1"
        :timer="toastOptions.type"
        :color="toastOptions.type"
    >
        <v-icon :icon="toastOptions.icon"/>
        {{ alertMessage }}
        <template v-slot:actions>
            <v-btn v-if="toastOptions.dismissible" icon="mdi-close" @click="toastCompleted"/>
        </template>
    </v-snackbar>
</template>
